import { Component, OnInit, Input } from '@angular/core';
import { AuthService } from '../../auth.service';

@Component({
  selector: 'trophy',
  templateUrl: './trophy.component.html',
  styleUrls: ['./trophy.component.scss']
})
export class TrophyComponent implements OnInit {

  @Input() user: string;
  @Input() hide: boolean = true;

  public open = false;

  public trophySubscription;
  public trophies;

  constructor(private auth: AuthService) { }

  ngOnInit() {
  }

  ngOnChanges() {
    if(this.trophySubscription) this.trophySubscription.unsubscribe();
    if(this.user) {
      this.trophySubscription =
        this.auth.getUserTrophies(this.user).subscribe(trophies => {
          this.trophies = [];
          for(let i=trophies.length-1; i>=0; i--) {
            let identifier = trophies[i].$key;
            let components = identifier.split("_");
            let obj = {
              "category": components[0]
            }
            if(components.length > 1) {
              obj["callout"] = components[1];
            }
            console.log(obj);
            this.trophies.push(obj);
          }
        });
    }
  }

  ngOnDestroy() {
    if(this.trophySubscription) this.trophySubscription.unsubscribe();
  }

}



// WEBPACK FOOTER //
// /Users/nicholasgerard/Documents/Quibbl/quibbl/src/app/common/trophy/trophy.component.ts